import { render, staticRenderFns } from "./muban.vue?vue&type=template&id=f869a492"
import script from "./muban.vue?vue&type=script&lang=js"
export * from "./muban.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports